module.exports = __webpack_public_path__ + "static/media/bird_fly05.6417e928.gif";